export default function PostTypeBadge({ type, label }) {
	return (
		<p
			class={`px-3 py-2 text-sm inline-flex items-center font-bold ${
				type === 'actor'
					? 'bg-light-red'
					: type === 'organization'
					? 'bg-light-yellow'
					: 'bg-light-blue'
			}`}
		>
			{label}
		</p>
	);
}
